import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { BookedTrip, Flight } from '@ibe/models';
import { MybService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { HttpClient } from '@angular/common/http';
import { PassengerFlightInfo, Passenger } from '../../../../app.modules/models';
import { CheckoutAncillariesComponent } from './checkout-ancillaries.component';
import { BookingService } from '@ibe/services';
import { AncillaryListItem } from '@ibe.models/ancillary-list-item';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { environment } from '@environments/environment';

import * as fromStore from '../../../../store';
import { getBrandFeatures } from '@ibe/models/ui';
import * as BookedTripActions from '../../../../store/actions/booked-trip.actions';


@Component({
	selector: 'app-checkout-ancillaries',
	templateUrl: './checkout-ancillaries.component.html',
	styleUrls: ['./checkout-ancillaries.component.scss']
})
export class TAPCheckoutAncillariesComponent extends CheckoutAncillariesComponent
	implements OnInit, OnDestroy {

	// Page state
	isBookedTripsLoaded = false;
	private isAlive: boolean;

	// Data
	passengerInfo: Passenger;
	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booked_trip: BookedTrip;
	pnr: string;
	ancillaries: AncillaryListItem[];

	// Other
	flights: Flight[];
	flightIdentifier: string;

	// Index of item being removed
	isRemovingLoading: number | any = null;
	ancillariesAddedToPayWithMiles$: Observable<Array<Object>> = this.store.select(fromStore.getAncillariesAddedToPayWithMiles);
	ancillariesAddedToPayWithMiles: Array<Object>;

	milesSpended$: Observable<number> = this.store.select(fromStore.getTotalMilesToSpend);
	milesSpended: number = 0;

	currency = environment.currency;

	constructor(
		private store: Store<fromStore.State>,
		route: ActivatedRoute,
		router: Router,
		mybService: MybService,
		bookingService: BookingService,
		sidebarService: SidebarService,
		protected _http: HttpClient
	) {
		super(sidebarService, route, router, bookingService, mybService);
		this.isAlive = true;

		this.milesSpended$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.milesSpended = value;
			});

		this.bookedTrip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.booked_trip = value;
					if (this.booked_trip.stopover === true) {
						this.flights = this.booked_trip.flights.filter(
							flight => flight.is_stopover !== true
						);
					} else {
						this.flights = this.booked_trip.flights;
					}
					this.ancillaries = this.booked_trip.buildAncillaryListToPay();
				} else { // TODO: load booking from service and if not exists goto not-found
					this.router.navigate(['/my-bookings/not-found']);
				}
			});

		this.ancillariesAddedToPayWithMiles$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => this.ancillariesAddedToPayWithMiles = value);

	}

	ngOnInit(): void { }

	/**
	 * Get booking from service using PNR
	 */
	getBooking(): void {
		const pnr = this.route.snapshot.paramMap.get('pnr');
		if (this.mybService.getBooking(pnr)) {
			this.booked_trip = this.mybService.getBooking(pnr);

			if (this.booked_trip.stopover === true) {
				this.flights = this.booked_trip.flights.filter(
					flight => flight.is_stopover !== true
				);
			} else {
				this.flights = this.booked_trip.flights;
			}

			this.ancillaries = this.booked_trip.buildAncillaryListToPay();
		} else { // TODO for booking flow
			this.router.navigate(['/my-bookings/not-found']);
		}
	}

	/**
	 * Get all passengers in this booking
	 */
	TAP_getPassengers() {
		return this.mybService.getPassengers(this.booked_trip);
	}

	TAP_sumItemsCostPerPassager(passenger: PassengerFlightInfo, flight: Flight) {

		const brand = getBrandFeatures(flight.options.brand);
		const filteredBrands = brand.filter(cur => cur.type == 'extra');
		const fastTrackEnabledPrice = filteredBrands.find(cur => cur.id == 'fasttrack') ? filteredBrands.find(cur => cur.id == 'fasttrack')['price'] : 0;
		const loungeEnabledPrice = filteredBrands.find(cur => cur.id == 'lounge') ? filteredBrands.find(cur => cur.id == 'lounge')['price'] : 0;

		let cost = 0;
		if (!this.ancillariesAddedToPayWithMiles.find(item => item['name'] == 'Extra Bags'))
			cost += passenger.stops.filter(cur => cur.added_bags).length ? passenger.stops.filter(cur => cur.added_bags).reduce((acc, cur) => acc += cur.added_bags.reduce((sum, price) => sum + price, 0), 0) : 0;
		else
			cost += 0;

		if (!this.ancillariesAddedToPayWithMiles.find(item => item['name'] == 'Music Instruments'))
			cost += passenger.stops.filter(cur => cur.musicInstruments).length ? passenger.stops.filter(cur => cur.musicInstruments).reduce((acc, cur) => acc += cur.musicInstruments.reduce((sum, item) => sum + item.price, 0), 0) : 0;
		else
			cost += 0;

		if (!this.ancillariesAddedToPayWithMiles.find(item => item['name'] == 'Sports Equipment'))
			cost += passenger.stops.filter(cur => cur.sportsEquipment).length ? passenger.stops.filter(cur => cur.sportsEquipment).reduce((acc, cur) => acc += cur.sportsEquipment.reduce((sum, item) => sum + item.price, 0), 0) : 0;
		else
			cost += 0;

		if (!this.ancillariesAddedToPayWithMiles.find(item => item['name'] == 'Pets'))
			cost += passenger.stops.filter(cur => cur.pets).length ? passenger.stops.filter(cur => cur.pets).reduce((acc, cur) => acc += cur.pets.reduce((sum, item) => sum + item.price, 0), 0) : 0;
		else
			cost += 0;

		cost += passenger.stops.filter(cur => cur.specialMeals).length ? passenger.stops.filter(cur => cur.specialMeals).reduce((acc, cur) => acc += cur.specialMeals.price, 0) : 0;

		if (!this.ancillariesAddedToPayWithMiles.find(item => item['name'] == 'Lounge'))
			cost += passenger.stops.filter(cur => cur.loungeEnabled).length ? passenger.stops.filter(cur => cur.loungeEnabled).reduce((acc, cur) => acc += loungeEnabledPrice, 0) : 0;
		else
			cost += 0;
		if (!this.ancillariesAddedToPayWithMiles.find(item => item['name'] == 'Fast Track'))
			cost += passenger.stops.filter(cur => cur.fastTrackEnabled).length ? passenger.stops.filter(cur => cur.fastTrackEnabled).reduce((acc, cur) => acc += fastTrackEnabledPrice, 0) : 0;
		else
			cost += 0;
		cost += passenger.stops.filter(cur => cur.boughtSeat).length ? passenger.stops.filter(cur => cur.boughtSeat).reduce((acc, cur) => acc += cur.boughtSeat.price, 0) : 0;
		return cost;
	}

	TAP_sumPrices() {
		if (!this.booked_trip) {
			return 0;
		}

		return this.booked_trip.flights.reduce((sum, flight) => {
			return (
				sum +
				flight.passengerInfo.reduce(
					(accu, passenger) =>
						accu + this.TAP_sumItemsCostPerPassager(passenger, flight),
					0
				)
			);
		}, 0);
	}

	TAP_printTotal() {
		if (this.milesSpended && this.TAP_sumPrices() > 0)
			return this.TAP_formatMiles(this.milesSpended) + ' + ' + this.TAP_formatCash(this.TAP_sumPrices());
		if (this.milesSpended)
			return this.TAP_formatMiles(this.milesSpended);
		return this.TAP_formatCash(this.TAP_sumPrices());
	}

	openSidebar(sidebarRoute, flightId) {
		this.sidebarService.openSidebar([sidebarRoute, { flight: flightId }]);
	}

	handleRemoveClick(ancilliaryItem: AncillaryListItem, index: number) {
		this.isRemovingLoading = index;
		// DEV - for simulation purposes only - remove for prod
		setTimeout(() => {
			this.isRemovingLoading = null;
			this.removeAll(ancilliaryItem, index);
		}, 1400);
	}

	removeAll(ancilliaryItem: AncillaryListItem, index: number) {
		const passengerInfo = Object.assign([], ancilliaryItem.flight.passengerInfo);

		const newPassengerInfo = passengerInfo.map(passenger => {
			let stops = passenger.stops;
			switch (ancilliaryItem.name) {
				case 'Seats':
					stops = passenger.stops.map(info => Object.assign({}, info, { boughtSeat: null }));
					break;
				case 'Extra Bags':
					stops = passenger.stops.map(info => Object.assign({}, info, { added_bags: [] }));
					break;
				case 'Fast Track':
					stops = passenger.stops.map(info => Object.assign({}, info, { fastTrackEnabled: false }));
					break;
				case 'Lounge':
					stops = passenger.stops.map(info => Object.assign({}, info, { loungeEnabled: false }));
					break;
				case 'Sport Equipments':
					stops = passenger.stops.map(info => Object.assign({}, info, { sportsEquipment: [] }));
					break;
				case 'Music Instruments':
					stops = passenger.stops.map(info => Object.assign({}, info, { musicInstruments: [] }));
					break;
				case 'Pets':
					stops = passenger.stops.map(info => Object.assign({}, info, { pets: [] }));
					break;
				case 'Special Meals':
					stops = passenger.stops.map(info => Object.assign({}, info, { specialMeals: null }));
					break;
			}

			return Object.assign(new PassengerFlightInfo(null, null), passenger, { stops });

		});

		const flight = Object.assign(new Flight(null, null, null), ancilliaryItem.flight, { passengerInfo: newPassengerInfo });
		const booking = Object.assign(new BookedTrip(null, null, null), this.booked_trip, { flights: Object.assign([], this.booked_trip.flights, this.booked_trip.flights.map(el => el.id === flight.id ? flight : el)) });

		this.store.dispatch(new BookedTripActions.PutBookedTripAction(booking));

		// this.ancillaries.splice(index, 1);
	}

	TAP_hasDiscount(item) {
		return this.ancillariesAddedToPayWithMiles.find(value => value['name'] == item.name);
	}

	TAP_printValue(item) {
		const payWithMiles = this.ancillariesAddedToPayWithMiles.find(value => value['name'] == item.name);
		if (payWithMiles) {
			return ' ' + this.TAP_formatMiles(payWithMiles['total'] * payWithMiles['count']);
		} else {
			return this.TAP_formatCash(item.cost);
		}
	}

	TAP_formatMiles(value) {
		return value.toLocaleString('pt') + ' M';
	}

	TAP_formatCash(value) {
		value = parseFloat(value);
		return value.toLocaleString('pt', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + environment.currency.symbol;
	}

	goToPayment() {
		super.TAP_handleClose();
		window.scrollTo(0, 0);
		this.router.navigate(['my-bookings/purchase', this.booked_trip.pnr]);
	}

	ngOnDestroy(): void {
		this.isAlive = false;
	}
}
